import {
    CHATBOT_PAGE,
    SHOW_SPINNING,
    CHATBOT_ADD,
    CHATBOT_ADD_MESSAGE,
    CHATBOT_DELETE_MESSAGE,
    CHATBOT_ERROR,
    GET_CHATBOT,
    GET_REPLY,
    GET_FAIL,
} from "../types/types";
import axios from "axios";
import config from "../../../config";

const instance = axios.create({
    baseURL: config.SIM_API_URL,
    timeout: 30000,
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if(error.response.status === 403) {
        localStorage.setItem("role", '');
        localStorage.setItem("client", '');
        localStorage.setItem("client_id", '');
        localStorage.setItem("client_name", '');
        localStorage.setItem("client_email", '');
        window.location.href = "/login";
    }
    return Promise.reject(error);
});
export const reset = () => dispatch => {
    dispatch({
        type: CHATBOT_PAGE,
        payload: '',
    });
    dispatch({
        type: CHATBOT_ERROR,
        payload: '',
    });
    dispatch({
        type: CHATBOT_ADD_MESSAGE,
        payload: '',
    });
    dispatch({
        type: CHATBOT_DELETE_MESSAGE,
        payload: '',
    });
};

export const chatDescription = (data) => dispatch => {
    dispatch({
        type: CHATBOT_PAGE,
        payload: data,
    });
};

export const addChatbot = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/chatbot/add-chatbot", data)
        .then(res => {
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CHATBOT_ADD,
                payload: res.data.results,
            });
            dispatch({
                type: CHATBOT_ADD_MESSAGE,
                payload: res.data.msg,
            });
            console.log(res.data.msg);
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CHATBOT_ERROR,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};

export const updateChatbot = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/chatbot/update-chatbot", data)
        .then(res => {
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CHATBOT_ADD,
                payload: res.data.results,
            });
            dispatch({
                type: CHATBOT_ADD_MESSAGE,
                payload: res.data.msg,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CHATBOT_ERROR,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};

export const deleteChatbot = (data) => dispatch => {
    dispatch({type: SHOW_SPINNING, payload: true});
    instance
        .post("api/chatbot/delete-chatbot", data)
        .then(res => {
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CHATBOT_DELETE_MESSAGE,
                payload: res.data.msg,
            });
        })
        .catch(err => {
            dispatch({type: SHOW_SPINNING, payload: false});
            dispatch({
                type: CHATBOT_ERROR,
                payload: err.toString(),
            });
        })
};

export const getData = (data) => dispatch => {
    instance
        .post("api/chatbot/get-chatbot", data)
        .then(res => {
            dispatch({
                type: GET_CHATBOT,
                payload: res.data.results,
            });
        })
        .catch(err => {
        })
};

export const learningBot = (data) => dispatch => {
    instance
        .post("api/chatbot/learn-chatbot", data)
        .then(res => {
            dispatch({
                type: GET_REPLY,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({
                type: GET_FAIL,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};
export async function replyBot(data) {
    return await instance.post("api/chatbot/learn-chatbot", data);
}